export var paragraphPortalTokens = {
  defaultSize: "m",
  lineHeight: "150%",
  sizes: {
    xxxl: {
      fontVariant: {
        desktop: "xxxl",
        notDesktop: "xxl"
      },
      pb: 24
    },
    xxl: {
      fontVariant: {
        desktop: "xxl",
        notDesktop: "xl"
      },
      pb: 16
    },
    xl: {
      fontVariant: {
        desktop: "xl",
        notDesktop: "l"
      },
      pb: 12
    },
    l: {
      fontVariant: {
        desktop: "l",
        notDesktop: "m"
      },
      pb: 9
    },
    m: {
      fontVariant: {
        desktop: "m",
        notDesktop: "s"
      },
      pb: 8
    },
    s: {
      fontVariant: "s",
      pb: 7
    },
    xs: {
      fontVariant: "xs",
      pb: 6
    }
  }
};